import { useState } from "react";
import styled from "styled-components";
import classNames from "classnames";

const Container = styled.button`
  background-color: ${(props) => props.theme.colours.white};
  border: 0;
  z-index: 10;
`;

const Bar = styled.div`
  width: 25px;
  height: 3px;
  background-color: ${(props) => props.theme.colours.primary};
  margin: 4px 0;
  transition: 0.3s;
  border-radius: 5px;
`;

const BarOne = styled(Bar)`
  ${({ menuOpen }) =>
    menuOpen &&
    `
    -webkit-transform: rotate(-45deg) translate(-4px, 4px);
    transform: rotate(-45deg) translate(-4px, 4px);
  `}
`;

const BarTwo = styled(Bar)`
  ${({ menuOpen }) =>
    menuOpen &&
    `
    opacity: 0;
`}
`;

const BarThree = styled(Bar)`
  ${({ menuOpen }) =>
    menuOpen &&
    `
    -webkit-transform: rotate(45deg) translate(-6px, -6px);
    transform: rotate(45deg) translate(-6px, -6px);
  `}
`;

export const BurgerMenu = ({ className, menuOpen, setMenuOpen }) => {
  const containerClasses = classNames(`burger-menu`, className);
  const [isAriaExpanded, setIsAriaExpanded] = useState(false);

  return (
    <Container
      aria-label="Main menu"
      aria-controls="menu"
      aria-expanded={isAriaExpanded}
      className={containerClasses}
      onClick={() => {
        setMenuOpen(!menuOpen);
        setIsAriaExpanded(!isAriaExpanded);
      }}
    >
      <BarOne className={`burger-menu__bar-one`} menuOpen={menuOpen} />
      <BarTwo className={`burger-menu__bar-two`} menuOpen={menuOpen} />
      <BarThree className={`burger-menu__bar-three`} menuOpen={menuOpen} />
    </Container>
  );
};
